const password = {
    unsupported_encryption_method: '不支持的加密方法 {{name}}',
    pepper_not_found: '密碼 pepper 未找到。請檢查 core 的環境變量。',
};
export default password;
